import { render, staticRenderFns } from "./estatisticas-qualidade.vue?vue&type=template&id=36107cf4&scoped=true"
import script from "./estatisticas-qualidade.vue?vue&type=script&lang=js"
export * from "./estatisticas-qualidade.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-qualidade.vue?vue&type=style&index=0&id=36107cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36107cf4",
  null
  
)

export default component.exports